// src/components/DropdownWithPlaceholder.js

const DropdownWithPlaceholder = ({
    items,
    label,
    setSelectedValue,
    selectedValue = "",
}) => {
    // const handleChange = (event) => {
    //     console.log(event.target);

    //     setSelectedValue(event.target.value);
    // };
    // console.log(selectedValue);

    return (
        <div className="flex items-center justify-between space-x-4">
            <select
                id="dropdown"
                className={`block px-3 py-2 border border-gray-600 rounded-md bg-white text-gray-700 shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
                onChange={(e) => setSelectedValue(Number(e.target.value))}
                value={selectedValue}
            >
                <option value="">
                    Select {label}
                </option>
                {items.map((item, index) => (
                    <option key={index} value={item.value}>
                        {item.label}
                    </option>
                ))}
            </select>

        </div>
    );
};

export default DropdownWithPlaceholder;
